import { Toolbar } from './components/Toolbar';
import { ObjectList } from './components/ObjectList';
import { SettingsPanel } from './components/SettingsPanel';
import { PlateViewer } from './scene/PlateViewer';
import { useAppStore } from './store/appStore';
import { store } from './store/appStore';

export default function App() {
  const settingsOpen = useAppStore((s) => s.settingsOpen);

  return (
    <div className="app">
      <Toolbar />
      <div className="workspace">
        <ObjectList />
        <main className="viewport">
          <PlateViewer />
        </main>
        <div className={`settings-wrap ${settingsOpen ? 'open' : ''}`}>
          <div
            className="sheet-handle mobile-only"
            onClick={() => store.set({ settingsOpen: false })}
          />
          <SettingsPanel />
        </div>
      </div>
    </div>
  );
}
